module.exports = __webpack_public_path__ + "static/media/preloader-Big-PennyMac-withText-combined.b949ae0b.gif";